import { QueryClient } from '@tanstack/react-query';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_QUERY_KEYS } from '../../constants';
import { ProductSearchItem, SearchQueryParams } from '../../model';

type Params = {
    queryKey: string;
    signal?: AbortSignal;
    clientIp?: string;
};

export const loadProductsCustomQuery = async ({ queryKey, signal, clientIp }: Params) => {
    const searchParams: SearchQueryParams = {
        searchText: '',
    };

    const response = await apiGetSearchQuery<ProductSearchItem>(queryKey, searchParams, signal, clientIp);

    return response.data;
};

export const prefetchProductsCustomQuery = (queryClient: QueryClient, params: Params) => {
    const { queryKey } = params;

    return queryClient.prefetchQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_PRODUCTS_CUSTOM_QUERY, queryKey],
        queryFn: () => loadProductsCustomQuery(params),
    });
};
